import { OperacaoParcela } from './model/operacaoParcela';

export type TotaisParcelasQuitacao = {
  valorBruto: number;
  desconto: number;
  saldoDevedor: number;
};

const numeroSeguro = (valor: number | null | undefined): number => {
  return typeof valor === 'number' && !isNaN(valor) ? valor : 0;
};

export const getParcelaQuitacaoKey = (parcela: OperacaoParcela): string => {
  return String(parcela.id ?? parcela.numeroParcela ?? '');
};

export const isParcelaQuitada = (parcela: OperacaoParcela): boolean => {
  return parcela.tipoMovimentacao != null
    && parcela.tipoMovimentacao.startsWith('BAIXA')
    && parcela.tipoMovimentacao !== 'BAIXA_PARCIAL';
};

const isParcelaComSaldoAberto = (parcela: OperacaoParcela): boolean => {
  return !parcela.tipoMovimentacao
    || parcela.tipoMovimentacao === 'EM_ABERTO'
    || parcela.tipoMovimentacao === 'BAIXA_PARCIAL';
};

export const calcularValorBrutoParcelaQuitacao = (parcela: OperacaoParcela): number => {
  const valorParcela = numeroSeguro(parcela.valorParcela);
  const valorPago = numeroSeguro(parcela.valorPago);

  if (isParcelaQuitada(parcela)) {
    return 0;
  }

  if (isParcelaComSaldoAberto(parcela)) {
    return Math.max(0, valorParcela - valorPago);
  }

  return valorParcela;
};

export const calcularSaldoParcelaQuitacao = (parcela: OperacaoParcela): number => {
  if (isParcelaQuitada(parcela)) {
    return 0;
  }

  return numeroSeguro(parcela.saldo);
};

export const calcularTotaisParcelasQuitacao = (parcelas: OperacaoParcela[]): TotaisParcelasQuitacao => {
  const valorBruto = parcelas.reduce(
    (total, parcela) => total + calcularValorBrutoParcelaQuitacao(parcela),
    0
  );
  const saldoDevedor = parcelas.reduce(
    (total, parcela) => total + calcularSaldoParcelaQuitacao(parcela),
    0
  );

  return {
    valorBruto,
    saldoDevedor,
    desconto: valorBruto - saldoDevedor,
  };
};
